import script from "./CertificateIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificateIndex.vue?vue&type=script&setup=true&lang=ts"

import "./CertificateIndex.vue?vue&type=style&index=0&id=672c443e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672c443e"]])

export default __exports__